export class Metodopagamento {
  Nome: string;
  Id: number;
  Descrizione: string;

  constructor(){
    this.Nome='';
    this.Id=0;
    this.Descrizione='';
  }
}
